export default __webpack_public_path__ + "static/media/chatsend-icon.b66bc623.png";